import './modal-file-preview.scss';

export default class ModalFilePreviewController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('angular').ISCEService} $sce
	 * @param {any} file
	 * @param {any} url
	 */
	constructor($uibModalInstance, $sce, file, url) {
		this.$uibModalInstance = $uibModalInstance;
		this.file = file;
		this.type = file.type;
		this.url = url;
	}

	close() {
		this.$uibModalInstance.close();
	}
}
